import { useUnit } from 'effector-react';

import { SUPPORT_URL } from '@m/constants/Contacts';
import OnboardingHeader from 'apps/customer/containers/OnboardingFlow/components/OnboardingHeader';

import { onboardingSessionStore } from './onboardingSession';
import { OnboardingStep } from './OnboardingStep';
import { stepOrderFor } from './stepOrder';
import { STEPPER_VISIBLE_STEPS } from './stepRoutes';

import type { OnboardingVariant } from '../deriveVariant';

export type ContainerHeaderProps = {
  /** Set only while a step has registered its own back behavior (currently just
   *  `VehicleSaveOptionsFlow`'s second sub-step, "go back to plate entry"). */
  backOverride: { fn: () => void } | null;
  currentStep: OnboardingStep;
  onClose: () => void;
  variant: OnboardingVariant;
};

export default function ContainerHeader({
  backOverride,
  currentStep,
  onClose,
  variant,
}: ContainerHeaderProps) {
  const { isReturningUser } = useUnit(onboardingSessionStore);
  const isLanding = currentStep === OnboardingStep.Landing;
  const showsStepper = STEPPER_VISIBLE_STEPS.has(currentStep);

  const order = stepOrderFor({ isNewAccount: isReturningUser === false, variant });
  const stepIndex = order.indexOf(currentStep);

  return (
    <OnboardingHeader
      hideBack={!backOverride}
      showClose={isLanding}
      onClose={onClose}
      onBack={backOverride ? () => backOverride.fn() : undefined}
      onHelp={() => window.open(SUPPORT_URL, '_blank', 'noopener,noreferrer')}
      steps={
        showsStepper && stepIndex >= 0
          ? order.map((step, index) => ({
              isActive: index === stepIndex,
              isComplete: index < stepIndex,
            }))
          : undefined
      }
    />
  );
}
